import { render } from "./PropertyStatusModals.vue?vue&type=template&id=1665ac2a&scoped=true"
import script from "./PropertyStatusModals.vue?vue&type=script&lang=js"
export * from "./PropertyStatusModals.vue?vue&type=script&lang=js"

import "./PropertyStatusModals.vue?vue&type=style&index=0&id=1665ac2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1665ac2a"]])

export default __exports__